module.exports = __webpack_public_path__ + "img/p3_3.1b048eaf.webp";